import { ActivatedRouteSnapshot } from '@angular/router';

export const getDeepestRoute = (route: ActivatedRouteSnapshot): ActivatedRouteSnapshot => {
  while (route.firstChild) {
    route = route.firstChild;
  }

  return route;
};

export const hasRouteFlag = (route: ActivatedRouteSnapshot, flag: string): boolean => {
  return !!route.data?.[flag];
};
